'use client';

import dynamic from 'next/dynamic';

const LoginPage = dynamic(() => import('./LoginPage'), {
  ssr: false,
  loading: () => <div className="min-h-screen" />
});

export default function LoginClient() {
  return <LoginPage />;
}
